"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppConfig = createAppConfig;
function createAppConfig(appConfig) {
    return appConfig;
}
//# sourceMappingURL=createAppConfig.js.map